import { render, staticRenderFns } from "./StatusProcessoSelect.vue?vue&type=template&id=5af978e2&"
import script from "./StatusProcessoSelect.vue?vue&type=script&lang=js&"
export * from "./StatusProcessoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports